import moment from "moment";

const DateTimeFormatter = (date) =>
moment(new Date(date)).format("MMM-DD-YYYY HH:mm");

const getSizeinKB = (bytes) => {
  return (bytes/1024).toFixed(2) + " Kb"
}

const YearFormat = () =>
moment(new Date()).format("YYYY");

// Backend now returns raw_image_url/processed_image_url as host-relative
// paths ("/media/processed/xxx.jpg") instead of a full URL, so a host/port.
// it's already absolute, so any row the DB migration didn't touch still works.
const resolveMediaUrl = (url) => {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) return url;
  const base = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
  return `${base}${url}`;
};

export {
  DateTimeFormatter,
  getSizeinKB,
  YearFormat,
  resolveMediaUrl
};